import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';
import PaiTextArea from '../../ui/base-components/pai-text-area';
import PaiTextField from '../../ui/base-components/pai-text-field';

interface Props {
  open: boolean;
  loading: boolean;
  functionName: string;
  prompt: string;

  handleFunctionNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handlePromptChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  handleEditFunction(): void;
}

const EditFunctionDialog: React.FC<Props> = ({
  open,
  loading,
  functionName,
  prompt,
  handleFunctionNameChange,
  handlePromptChange,
  handleClose,
  handleEditFunction,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('editFunction')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <PaiTextField value={functionName} label={t('functionName')} placeholder={t('enterFunctionNameHere')} onChange={handleFunctionNameChange} />
          <PaiTextArea value={prompt} label={t('prompt')} placeholder={t('enterPromptHere')} rows={8} onChange={handlePromptChange} />
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton
          text={t('ok')}
          action={handleEditFunction}
          disabled={functionName.trim() === '' || prompt.trim() === '' || loading}
          loading={loading}
        />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  title: {
    background: theme.palette.primary.main,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '16px !important',
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default EditFunctionDialog;
